<script lang="ts">
  import type { ApiField, RelationCard } from '../data-tables-api';
  import { resolveCard } from './linked-cache';
  import RelationBubble from './RelationBubble.svelte';

  let {
    field,
    value,
    /** dense=true у клітинках таблиці; false (default) у detail-view. */
    dense = false,
    /** Скільки bubble показати до згортання у "+K". */
    max = 8,
  }: {
    field: ApiField;
    value: unknown;
    dense?: boolean;
    max?: number;
  } = $props();

  const slug = $derived(field.target_slug ?? null);
  const isMany = $derived(field.cardinality === 'many');

  /** Нормалізуємо value → масив рядків-id. */
  const ids = $derived.by((): string[] => {
    if (isMany) {
      if (Array.isArray(value)) return value.filter((v) => v != null && v !== '').map(String);
      if (value != null && value !== '') return [String(value)];
      return [];
    }
    const s = value != null && value !== '' ? String(value) : '';
    return s ? [s] : [];
  });

  /** id → RelationCard (батч-резолв через cache). */
  let cards = $state<Map<string, RelationCard>>(new Map());

  $effect(() => {
    if (!slug || ids.length === 0) { cards = new Map(); return; }
    const s = slug;
    let cancelled = false;
    Promise.all(ids.map(async (id) => [id, await resolveCard(s, id)] as const)).then((pairs) => {
      if (!cancelled) cards = new Map(pairs);
    });
    return () => { cancelled = true; };
  });

  let expanded = $state(false);
  const shown = $derived(expanded ? ids : ids.slice(0, max));
  const hidden = $derived(ids.length - shown.length);
</script>

{#if ids.length === 0}
  <span class="text-[var(--color-text-muted)]">—</span>
{:else if slug}
  <span class="inline-flex flex-wrap items-center gap-1">
    {#each shown as id (id)}
      <RelationBubble card={cards.get(id) ?? null} slug={slug} {id} {dense} />
    {/each}
    {#if hidden > 0}
      <button
        type="button"
        onclick={() => (expanded = true)}
        class="inline-flex items-center rounded-full border border-[var(--color-border-3)] bg-[var(--color-bg-3)] px-2 py-0.5 text-[11px] font-medium text-[var(--color-text-muted)] hover:bg-white"
      >+{hidden}</button>
    {/if}
  </span>
{/if}
